import React from 'react';
import './index.scss';

type DeviceIconCommonProps = {
  icon: React.ReactNode;
  statusIcon?: React.ReactNode;
};

const DeviceIconCommon: React.FC<DeviceIconCommonProps> = ({ icon, statusIcon }) => (
  <div className="device-icon m-r-16">
    <div className="device-icon--main">{icon}</div>
    {statusIcon ? statusIcon : null}
  </div>
);

export default DeviceIconCommon;
